// classes import
import { CustomerModelProvider } from './customer-model';
import { BaseTransactionModelProvider } from './base-transaction-model';
import { TransitModelProvider } from './transit-model';
import { ConsignmentModelProvider } from './consignment-model';
import { SaleModelProvider } from './sale-model';
import { EosModelProvider } from './eos-model';
import { SessionObjectProvider } from './session-object';

export const classes = [
  // classes export
  CustomerModelProvider,
  BaseTransactionModelProvider,
  TransitModelProvider,
  ConsignmentModelProvider,
  SaleModelProvider,
  EosModelProvider,
  SessionObjectProvider,
];
